import React, { useEffect, useState } from 'react';
import ImageComponent from 'atoms/Image/index';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { MENU_PDP_PAGE_CONSTANTS } from 'organisms/MenuPDPPage/AU/Constants/MenuPDPPageConstants';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import { getTernaryValue, isCateringDisposition, truncateWords } from 'common/utilities/utils';

const ProductDescription = props => {
  const { longDescription, isMobile, dispositionType } = props;
  const { SHORT, READ_MORE, READ_LESS, LONG, MAX_LENGTH_READ } = MENU_PDP_PAGE_CONSTANTS;
  const [longDesc, setLongDesc] = useState('');
  const [readType, setReadType] = useState(SHORT);

  useEffect(() => {
    if (longDescription) {
      setLongDesc(longDescription);
    }
  }, [longDescription]);

  const toggleDesc = () => {
    if (readType === SHORT) {
      setReadType(LONG);
    } else {
      setReadType(SHORT);
    }
  };

  const renderForMobile = () => {
    return (
      <div className='desc-box mobile-desc-text'>
        {readType === SHORT ? truncateWords(longDesc, MAX_LENGTH_READ, false) : longDesc}
        {longDesc?.length > MAX_LENGTH_READ ? (
          <span className='readMoreLess' data-testid='read-more-less' onClick={toggleDesc}>
            {(readType === SHORT && translateWithI18Next(READ_MORE)) || translateWithI18Next(READ_LESS)}
          </span>
        ) : (
          <></>
        )}
      </div>
    );
  };

  const renderForDesktop = () => {
    return <div className='desc-box'>{longDesc}</div>;
  };

  return (
    <div className='pdp-desc'>
      <div className='d-flex mb-4 mobile-desc'>
        <ImageComponent
          srcFile={isMobile ? IMAGE_PATH.StripsIconMobile : IMAGE_PATH.StripesIcon}
          className='stripes-img'
        />
      </div>
      <h2 className='pdp-desc-header mobile-desc'> {getMealText(translateWithI18Next, dispositionType)} </h2>
      {isMobile ? renderForMobile() : renderForDesktop()}
    </div>
  );
};

export default ProductDescription;

function getMealText(translateWithI18NextValue, dispositionType) {
  const mealText = getTernaryValue(
    isCateringDisposition(dispositionType),
    MENU_PDP_PAGE_CONSTANTS.BUNDLE_OPTIONS,
    MENU_PDP_PAGE_CONSTANTS.MEAL_OPTIONS,
  );
  return translateWithI18NextValue(mealText);
}
